import { useNavigate } from 'react-router-dom'
import { Play, Star } from 'lucide-react'

const estiloLabels = {
  teorico: { text: 'Teórico', class: 'bg-gray-100 text-gray-700' },
  pratico: { text: 'Prático', class: 'bg-emerald-50 text-emerald-700' },
  revisao_rapida: { text: 'Revisão', class: 'bg-amber-50 text-amber-700' },
  exercicios: { text: 'Exercícios', class: 'bg-violet-50 text-violet-700' },
  preparacao_prova: { text: 'Prova', class: 'bg-red-50 text-red-700' }
}

function VideoaulaCard({ videoaula, contextLabel }) {
  const navigate = useNavigate()
  const estilo = estiloLabels[videoaula.estilo] || estiloLabels.teorico

  const formatDuration = (segundos) => {
    const min = Math.floor(segundos / 60)
    return `${min} min`
  }

  return (
    <div
      onClick={() => navigate(
        videoaula.fonte === 'youtube'
          ? `/videoaula/youtube/${videoaula.youtube_id}`
          : videoaula.fonte === 'recomendacao'
            ? `/recomendacao/${videoaula.id}`
          : `/videoaula/${videoaula.id}`
      )}
      className="flex gap-3 p-3 rounded-xl border border-gray-100 hover:border-gray-300 hover:shadow-sm transition-all cursor-pointer active:scale-[0.98]"
    >
      {/* Thumbnail */}
      <div className="relative w-28 h-20 bg-gray-100 rounded-lg flex-shrink-0 overflow-hidden">
        {videoaula.thumbnail_url ? (
          <img
            src={videoaula.thumbnail_url}
            alt={videoaula.titulo}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Play size={20} className="text-gray-400" />
          </div>
        )}
        <div className="absolute bottom-1 right-1 bg-black/70 text-white text-[10px] px-1.5 py-0.5 rounded">
          {videoaula.duracao_segundos ? formatDuration(videoaula.duracao_segundos) : 'Aula'}
        </div>
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-medium leading-tight line-clamp-2 mb-1">
          {videoaula.titulo}
        </h3>
        <p className="text-xs text-gray-500 mb-1.5">
          {videoaula.professor} • {videoaula.canal}
        </p>
        <div className="flex items-center gap-2">
          {contextLabel && (
            <span className="max-w-28 truncate rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-700 dark:bg-blue-950 dark:text-blue-300">
              {contextLabel}
            </span>
          )}
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${estilo.class}`}>
            {estilo.text}
          </span>
          {videoaula.avaliacao_media > 0 && (
            <span className="flex items-center gap-0.5 text-[10px] text-amber-600">
              <Star size={10} fill="currentColor" />
              {videoaula.avaliacao_media}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default VideoaulaCard
